import {useContext, useEffect, useState} from "react";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import PanelRightContent from "../../layouts/mainPanel/PanelRightContent";
import PanelLeftContent from "../../layouts/mainPanel/PanelLeftContent";
import {Image, ProgressBar, Tab, Tabs} from "react-bootstrap";
// import ReactStars from "react-rating-stars-component";
import GeneralInfo from "./GeneralInfo";
import OrgUsers from "./OrgUsers";
import OrgPost from "./OrgPost";
import Packages from "./Packeges/Packages";
import {buildStyles, CircularProgressbarWithChildren,} from "react-circular-progressbar";
import {del, get} from "../../controlers/global/ConfigRequest";
import {COMPANY_DETAIL, GET_COMPANY_MONEY_COINS} from "../../helperData/ApiAddress";
import {ToastContext} from "../../component/global/ToastContext";
import {GlobalStateContext} from "../../layouts/GlobalStates";
import IconBox from "../../component/global/IconBox";
import {useTranslation} from "react-i18next";
import avatar from "../../asset/image/avatar.png";
import {ReactComponent as CameraIcon} from "../../asset/icons/cameraIcon.svg";
// import {ReactComponent as StarIcon} from "../../asset/icons/starIcon.svg";
// import {ReactComponent as EmptyStarIcon} from "../../asset/icons/emptyStarIcon.svg";
import "./style.scss";

const Profile = () => {
  const [activeTab, setActiveTab] = useState(
    () => new URLSearchParams(window.location.search).get("tab") || "1"
  );
  const [completeProfile, setComleteProfile] = useState(50);
  const [companyList, setCompanyList] = useState();
  const show = useContext(ToastContext);
  let [form, setForm] = useState({
    name: "",
    logo: null,
    web_url: "",
    phone_number: "",
    email: "",
    contract_number: "",
    address: "",
    translates: [],
    category: null,
    business_types: [],
  });
  let [disable, setDisable] = useState(true);
  let [mode, setMode] = useState("new"); // or edit
  const {auth} = useContext(GlobalStateContext);
  const {t} = useTranslation();
  const [coin, setCoin] = useState(0)

  useEffect(() => {
    console.log('auth.usertype', auth.usertype)
    if (auth.usertype === 1) {
      get(COMPANY_DETAIL.replace("{id}/", ""))
        .then((r) => {
          setCompanyList(r);
          setForm(r.results[0]);
          setDisable(false);
        });
    } else {
      if (auth.usertype === 2) {
        get(COMPANY_DETAIL.replace("{id}", auth.usercompany))
          .then((r) => {
              setForm(r);
              setDisable(false);
              setMode("edit");
            }
          );
      }
    }
  }, [auth.usercompany, auth.usertype]);

  useEffect(() => {
    get(GET_COMPANY_MONEY_COINS)
      .then(res => {
        console.log('profile res', res)
        setCoin(res.filter((r) => r.account_type === 2)[0]?.balance);
        // setMoney(r.filter((r) => r.account_type === 1)[0]?.balance);
      })
      .catch(err => {
        console.log('profile err', err)
      })
  }, [])

  const removeCompanyHandle = (id) => {
    del(COMPANY_DETAIL.replace("{id}", id))
      .then((r) => {
        let companyListClone = Object.assign([], companyList.results);
        for (let i = 0; i < companyListClone.length; i++) {
          if (companyListClone[i].id === id) {
            delete companyListClone[i];
            break;
          }
        }
        setCompanyList({...companyList, results: companyListClone});
      })
      .catch(() => {
        show(t("Src.Pages.Profile.Index.Danger.Err"), "danger");
      });
  };

  const updateCompanyHandle = (id) => {
    setMode("edit");
    setForm(companyList.results.filter((row) => row.id === id)[0]);
  };

  const addNewCompanyHandle = () => {
    setMode("new");
    setForm({
      name: "",
      logo: null,
      web_url: "",
      phone_number: "",
      email: "",
      contract_number: "",
      address: "",
      translates: [],
      category: null,
      business_types: [],
    });
  };

  return (
    <div className=" main_panel_box profile" key={auth.username}>
      <MainPanelHeader/>
      <div className="profile_content main_panel_content">
        <PanelRightContent>
          <div className="tab-section">
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(e) => setActiveTab(e)}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t("Organizational.Profile.GeneralInformation.Label")}
              >
                <GeneralInfo
                  {...{
                    form,
                    setForm,
                    disable,
                    setDisable,
                    companyList,
                    setCompanyList,
                    mode,
                    auth,
                  }}
                />
              </Tab>
              <Tab
                eventKey="2"
                className="panel_tab_item"
                title={t("Organizational.Profile.OrgUsers.Tab")}
              >
                <OrgUsers
                  {...{
                    form,
                    auth,
                  }}
                  key={`users-${form?.id || auth.usercompany}`}
                />
              </Tab>
              <Tab
                eventKey="3"
                className="panel_tab_item"
                title={t("Organizational.Profile.AddNewPosition.Tab")}
              >
                <OrgPost
                  {...{
                    form,
                    setForm,
                    disable,
                    setDisable,
                    companyList,
                    setCompanyList,
                    mode,
                    auth,
                  }}
                  key={`posts-${activeTab}-${form?.id || auth.usercompany}`}
                />
              </Tab>
              <Tab
                eventKey="4"
                className="panel_tab_item"
                title={t("Organizational.Profile.Packages.Tab")}
              >
                <Packages/>
              </Tab>
            </Tabs>
          </div>
        </PanelRightContent>
        <PanelLeftContent>
          {auth.usertype === 1 ? (
            <>
              <div>
                <div className="admin-company-list-head">
                  <div>
                    {t("Organizational.Profile.Organization.List")}
                  </div>
                  <div>
                    {activeTab === "1" && (
                      <IconBox
                        clickFunction={
                          addNewCompanyHandle
                        }
                        iconName="plusIconLarge"
                        specialClass="blue_border_box"
                        size="large_icon"
                      />
                    )}
                  </div>
                </div>
                <div className="admin-company-list">
                  {companyList?.results.map((r) => (
                    <div
                      style={{
                        backgroundColor:
                          form.id === r.id
                            ? "#2E71FC"
                            : "transparent",
                        color:
                          form.id === r.id
                            ? "white"
                            : "#333",
                      }}
                      onClick={() =>
                        updateCompanyHandle(r.id)
                      }
                    >
                      <div>{r.name}</div>
                      <div>
                        {activeTab === "1" && (
                          <IconBox
                            iconName={"trashIcon"}
                            specialClass={
                              "dark_gray_box"
                            }
                            size={"small_icon"}
                            clickFunction={() =>
                              removeCompanyHandle(
                                r.id
                              )
                            }
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div id="profile-info">
              <div className="avatar-section">
                <div className="percent">
                  {completeProfile}%
                </div>
                <div className="avatar-image">
                  <div className="avatar-border"></div>
                  <CircularProgressbarWithChildren
                    value={completeProfile}
                    counterClockwise
                    strokeWidth={4}
                    styles={buildStyles({
                      strokeLinecap: "butt",
                    })}
                  >
                    <Image src={form.logo || avatar} alt="avatar"/>
                  </CircularProgressbarWithChildren>

                  <div className="add-avatar">
                    <CameraIcon/>
                  </div>
                </div>
                <div className="activity">فعال</div>
              </div>
              <div className="name">{form.name}</div>
              {/*<div className="rating-stars">*/}
              {/*  <ReactStars*/}
              {/*    edit={false}*/}
              {/*    value={5}*/}
              {/*    count={5}*/}
              {/*    size={24}*/}
              {/*    activeColor="#FEB730"*/}
              {/*    filledIcon={<StarIcon/>}*/}
              {/*    emptyIcon={<EmptyStarIcon/>}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className="bio">*/}
              {/*  ورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از*/}
              {/*  صنعت چاپ و با استفاده از طراحان گرافیک است.*/}
              {/*  چاپگرها و متون بلکه روزنامه و مجله در ستون*/}
              {/*</div>*/}
              <div className="score-section">
                <div className="score-title">
                  <div>{t('Organizational.Profile.Total.Coin')} : {coin}</div>
                  {/*<div>فیدیما کوشا</div>*/}
                  <div></div>
                </div>
                <ProgressBar>
                  <ProgressBar now={10} key={1}/>
                  <ProgressBar now={20} key={2}/>
                  <ProgressBar now={20} key={3}/>
                  <ProgressBar now={20} key={4}/>
                  <ProgressBar now={0} key={5}/>
                  <ProgressBar now={0} key={6}/>
                </ProgressBar>
                <div className="progress-caption">
                  <div>100</div>
                  <div>500</div>
                  <div>1000</div>
                  <div>1500</div>
                  <div>3000</div>
                </div>
              </div>
              <div className="contact-info">
                <div>{form.phone_number}</div>
                <div>{form.email}</div>
                <div>{form.address}</div>
                <a href="#3">
                  {t("Organizational.Profile.Change.Password")}
                </a>
              </div>
            </div>
          )}
        </PanelLeftContent>
      </div>
    </div>
  );
};

export default Profile;
